import React from 'react';

interface StatisticsProps {
  name: string;
  value: number;
}

const Statistics = ({ name, value }: StatisticsProps) => {
  return (
    <div className="flex-1 border-0 border-t-4 border-solid border-t-primary-magenta bg-grayscale-beige px-[18px] pb-12 pt-20 md:max-w-[303px]">
      <dl className="m-0">
        <dt className="m-0 font-suisse-intl-mono text-overline-md text-black">{name}</dt>
        <dd className="m-0 font-suisse-works text-headline-lg text-black">
          {value.toLocaleString('en-US')}
        </dd>
      </dl>
    </div>
  );
};

export default Statistics;
